import React from 'react'
import { VISUAL_ACUITY } from '../../../Constants'
import { connect } from 'react-redux'

function SetDistanceNear(props) {
  const { visual, setVisualAcuity, wrapperClass, isDropLeft, measurementType } = props
  const measurement = measurementType === 'metric' ? '6/' : '20/'
  const measurementValue = measurementType === 'metric' ? '6' : '20'

  return (
    <div className={`col-6 mb-5 text-right ${wrapperClass}`}>
      <div className={`${isDropLeft && 'btn-group'}`}>
        <div className={`btn-group ${isDropLeft ? 'dropleft' : 'dropright mr-4 mb-4'}`}>
          {!isDropLeft && <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => setVisualAcuity(visual, measurementValue)}>{measurement}{measurementValue}</button>}
          <button type="button" className="btn btn-outline-primary dropdown-toggle dropdown-toggle-split btn-sm dropdownDistanceNear" data-toggle="dropdown" aria-expanded="false">
            <span className="sr-only">Toggle Dropdown</span>
          </button>
          <div className={`dropdown-menu dropdown-menu-distance min-width-8 ${isDropLeft && 'left-dropdown'}`}>
            <div className="d-flex justify-content-center flex-column align-items-center pt-5">
              {VISUAL_ACUITY[measurementType].map(item => <button type="button" className="btn btn-outline-primary btn-sm mb-4" onClick={() => setVisualAcuity(visual, item)}>{`${measurement}${item}`}</button>)}
            </div>
          </div>
        </div>
        {isDropLeft &&
          <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => setVisualAcuity(visual, measurementValue)}>{measurement}{measurementValue}</button>}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { organisation: { organisation } } = state
  return {
    measurementType: organisation.preferences?.measurement,
  }
}

export default connect(mapStateToProps)(SetDistanceNear);